import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import {
    CROP_WH_16_10,
    CROP_WH_16_9,
    CROP_WH_1_1,
    CROP_WH_2_3, CROP_WH_3_2,
    CROP_WH_3_4,
    CROP_WH_3_5,
    CROP_WH_4_3,
    CROP_WH_4_5,
    CROP_WH_5_3,
    CROP_WH_5_4,
    TOOLBAR_CROP_WH,
} from '@editor/src/img/pageIndex';
import i18n from '@i18next/i18n';
import { MenuKey } from '@framework/workbench/schema/menu-schema/common';
import { TDWActionType, TDWModuleType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { wrapIdForBig } from '@src/framework/workbench/util/wrap-id-util';

export const config = {
    id: ActionType.TAILOR_PIC_WH,
    icon: TOOLBAR_CROP_WH,
    title: i18n.t('裁剪为纵横比'),
    twdConfig: {
        handleFunction: (value) => {
            if (!value) {
                return {};
            }
            let tailorObj;
            if (value === ActionType.TAILOR_PIC_NORMAL) {
                tailorObj = {
                    module: TDWModuleType.PC_TOOLBAR_PIC,
                    action: TDWActionType.PIC_CROP,
                };
            } else {
                tailorObj = {
                    module: TDWModuleType.PC_TOOLBAR_PIC,
                    action: TDWActionType.CROP_MENU,
                    ver5: value,
                };
            }
            return tailorObj;
        },
    },
};

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: `${config.id}`,
        content: config.title,
        tooltip: config.title,
        icon: <img src={config.icon} alt={''}/>,
    },
    { name: ActionType.TAILOR_PIC_WH_1_1, content: '1:1', tooltip: '1:1', icon: <img src={CROP_WH_1_1} alt={''}/> },
    { name: ActionType.TAILOR_PIC_WH_2_3, content: '2:3', tooltip: '2:3', icon: <img src={CROP_WH_2_3} alt={''}/> },
    { name: ActionType.TAILOR_PIC_WH_3_4, content: '3:4', tooltip: '3:4', icon: <img src={CROP_WH_3_4} alt={''}/> },
    { name: ActionType.TAILOR_PIC_WH_3_5, content: '3:5', tooltip: '3:5', icon: <img src={CROP_WH_3_5} alt={''}/> },
    { name: ActionType.TAILOR_PIC_WH_4_5, content: '4:5', tooltip: '4:5', icon: <img src={CROP_WH_4_5} alt={''}/> },
    { name: ActionType.TAILOR_PIC_WH_3_2, content: '3:2', tooltip: '3:2', icon: <img src={CROP_WH_3_2} alt={''}/> },
    { name: ActionType.TAILOR_PIC_WH_4_3, content: '4:3', tooltip: '4:3', icon: <img src={CROP_WH_4_3} alt={''}/> },
    { name: ActionType.TAILOR_PIC_WH_5_3, content: '5:3', tooltip: '5:3', icon: <img src={CROP_WH_5_3} alt={''}/> },
    { name: ActionType.TAILOR_PIC_WH_5_4, content: '5:4', tooltip: '5:4', icon: <img src={CROP_WH_5_4} alt={''}/> },
    { name: ActionType.TAILOR_PIC_WH_16_9, content: '16:9', tooltip: '16:9', icon: <img src={CROP_WH_16_9} alt={''}/> },
    { name: ActionType.TAILOR_PIC_WH_16_10, content: '16:10', tooltip: '16:10', icon: <img src={CROP_WH_16_10} alt={''}/> },
    // top menu config
    {
        name: MenuKey.TAILOR_PIC_WH,
        content: config.title,
        tooltip: config.title,
    },
    { name: MenuKey.TAILOR_PIC_WH_1_1, content: '1:1', tooltip: '1:1' },
    { name: MenuKey.TAILOR_PIC_WH_2_3, content: '2:3', tooltip: '2:3' },
    { name: MenuKey.TAILOR_PIC_WH_3_4, content: '3:4', tooltip: '3:4' },
    { name: MenuKey.TAILOR_PIC_WH_3_5, content: '3:5', tooltip: '3:5' },
    { name: MenuKey.TAILOR_PIC_WH_4_5, content: '4:5', tooltip: '4:5' },
    { name: MenuKey.TAILOR_PIC_WH_3_2, content: '3:2', tooltip: '3:2' },
    { name: MenuKey.TAILOR_PIC_WH_4_3, content: '4:3', tooltip: '4:3' },
    { name: MenuKey.TAILOR_PIC_WH_5_3, content: '5:3', tooltip: '5:3' },
    { name: MenuKey.TAILOR_PIC_WH_5_4, content: '5:4', tooltip: '5:4' },
    { name: MenuKey.TAILOR_PIC_WH_16_9, content: '16:9', tooltip: '16:9' },
    { name: MenuKey.TAILOR_PIC_WH_16_10, content: '16:10', tooltip: '16:10' },

];

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: wrapIdForBig(config.id),
        icon: <img src={config.icon} alt={''}/>,
        text: i18n.t('按比例裁剪'),
        tooltip: i18n.t('按比例裁剪'),
        hasArrow: true,
        style: {
            width: 'auto',
        },
    },
];
